<template>
  <div>
    <section class="section-shaped my-0">
      <div class="shape shape-style-2 shape-default shape-skew">
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </div>
      <div class="container text-center shape-container">
        <h1 class="display-3 text-white">
          Updating Umbai,
          <span>We are updating umbai, please check back soon</span>
        </h1>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "components",
  components: {},
};
</script>
